import React, { useEffect, useContext, useRef, useState, useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { ApiService } from "../../Component/services/apiServices";
import { BrowserView, MobileView } from "react-device-detect";
import { Navigation, Pagination } from "swiper/modules";
import { Autoplay } from "swiper/modules";
import Header from "../../Component/Header";
import Footer from "../../Component/Footer";
import AccountHeader from "../../Component/Header/account_header";
import { Swiper, SwiperSlide } from 'swiper/react';
import DataContext from "../../Component/context";
import CateringBooking from "./catering_booking";
 
function Catering() {
    const navigate = useNavigate();
    const didMountRef = useRef(true)
    const [testimonialData, setTestimonialData] = useState([]);
    const [baseimgUrl, setbaseimageUrl] = useState("");
    const [contactInputs, setcontactInputs] = useState({
        contact_name: "",
        contact_email: "",
        contact_mobile: "",
        contact_event_date: "",
        contact_call_time: "",
        contact_type: 1,
        contact_subject: "",
        contact_message: "",
    });
    const [errorMessage, seterrorMessage] = useState(false)
    const [successMessage, setsuccessMessage] = useState(false)
    const [buttonLoader, setButtonLoader] = useState(false)
    const contextValues = useContext(DataContext);
    const swiperModules = useMemo(() => [Autoplay, Pagination, Navigation], []);
    useEffect(() => {
        if (didMountRef.current) {
            fetchtestimonialdata()
        }
        didMountRef.current = false;
    }, [navigate])

    const closeCateringModal = () => {
        contextValues.setToggleCateringModal(false);
    };

    const handleContactInput = (e) => {
        seterrorMessage('')
        const { name, value } = e.target;
        setcontactInputs({
            ...contactInputs,
            [name]: value,
        });
    };

    const cateringModal = () => {
        contextValues.setToggleCateringModal(!contextValues.toggleCateringModal)
    }

    const ContactformHandle = () => {
        let counter = 0;
        const myElements = document.getElementsByClassName("required");
        for (let i = 0; i < myElements.length; i++) {
            if (myElements[i].value === '') {
                myElements[i].style.border = '1px solid red';
                counter++;
            } else {
                myElements[i].style.border = '';
            }
        }
        if (counter === 0) {
            if (contactInputs?.contact_name === "") {
                seterrorMessage('Please Enter Your Name')
                return;
            }
            if (contactInputs?.contact_email === "") {
                seterrorMessage('Please Enter Your Email Address')
                return;
            }
            const validEmail = new RegExp("^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$");
            if (!validEmail.test(contactInputs?.contact_email)) {
                seterrorMessage('Please Enter Valid Email Address');
                return;
            }
            if (contactInputs?.contact_mobile === "") {
                seterrorMessage('Please Enter Your Mobile Number');
                return;
            }
            setButtonLoader(true);
            ApiService.postData("contact-us-process", contactInputs).then(
                (res) => {
                    if (res?.status === "success") {
                        setsuccessMessage(res.message)
                        setcontactInputs((prevState) => ({
                            ...prevState,
                            contact_name: "",
                            contact_email: "",
                            contact_mobile: "",
                            contact_event_date: "",
                            contact_call_time: "",
                            contact_type: 1,
                            contact_subject: "",
                            contact_message: "",
                        }));
                        setButtonLoader(false);
                        setTimeout(() => {
                            setsuccessMessage("");
                        }, 3000);
                    } else if (res?.status === "error") {
                        setButtonLoader(false);
                        seterrorMessage(res.message);
                        setTimeout(() => {
                            seterrorMessage("");
                        }, 3000);
                    }
                }
            );
        }
    };

    const fetchtestimonialdata = useCallback(() => {
        ApiService.fetchData("featuredTestimonial").then((res) => {
            console.log(res, "res")
            if (res?.status === "success") {
                setbaseimageUrl(res?.testimonial_image_path);
                setTestimonialData(res?.testimonialData);
            } else {

            }
        }).catch((error) => {

        });
    }, []);

    return (
        <>
            <BrowserView>
                <Header />
                <video
                    style={{ width: '100%', height: '650px', objectFit: 'cover' }}
                    autoPlay
                    muted
                    loop
                >
                    <source src="/img/catering_intro.mp4" type="video/mp4" />
                </video>
                <section className="section-gap-sm services">
                    <div className="container">
                        <div className="section-title text-center">
                            <h2><span style={{ color: '#2ecc71' }}>Deliciously Different</span>&nbsp;<span style={{ color: '#3498db' }}>Exceptionally Memorable</span></h2>
                            <h5>Authentic Indian Vegetarian Catering Across Sydney</h5>
                            <p>At Daadi&#39;s Kitchen, we bring the warmth of traditional Indian flavours to your most cherished moments. As a 100% vegetarian caterer, we specialize in crafting fresh, home-style Indian cuisine for weddings, festivals, poojas, corporate events, and intimate gatherings.</p>
                            <p>With flexible staffed or unstaffed catering and pickup or delivery options available across Sydney, we make it effortless to serve up a feast your guests will love.</p>
                        </div>
                        <div className="row" style={{ textAlign: 'center' }}>
                            <div className="col-lg-12">
                                <h2 className="mb-3">Have a Catering Enquiry? Connect With Us!</h2>
                                <h4>Share Your Catering Requirements</h4>
                                <button type="button" className="btn-lg btn btn-primary mt-3" onClick={() => { cateringModal() }} >Make a Catering Enquiry Today</button>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="section-gap-md bg-light">
                    <div className="container">
                        <div className="flat-service">
                            <div className="row">
                                <div className="col-lg-3">
                                    <div className="box-service">
                                        <div className="icon-box">
                                            <img src="/img/catering.png" alt=""></img>
                                        </div>
                                        <div className="content">
                                            <h2 className="title">Live Catering</h2>
                                            <p class="description">Fresh dishes prepared on-site to deliver authentic flavours and a memorable dining experience.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3">
                                    <div className="box-service">
                                        <div className="icon-box">
                                            <img src="/img/onion.png" alt=""></img>
                                        </div>
                                        <div className="content">
                                            <h2 className="title">No Onion, No Garlic Menu</h2>
                                            <p class="description">Specially crafted pure vegetarian dishes made without onion and garlic, perfect for traditional and dietary preferences.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3">
                                    <div className="box-service">
                                        <div className="icon-box">
                                            <img src="/img/restaurant.png" alt=""></img>
                                        </div>
                                        <div className="content">
                                            <h2 className="title">Customisable Menu</h2>
                                            <p class="description">Choose from a wide range of Indian dishes tailored to your event’s needs.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3">
                                    <div className="box-service">
                                        <div className="icon-box">
                                            <img src="/img/fresh.png" alt=""></img>
                                        </div>
                                        <div className="content">
                                            <h2 className="title">Fresh & Hygienic Preparation</h2>
                                            <p class="description">Every dish is prepared with high-quality ingredients and strict hygiene standards.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wrap-counter">
                            <div class="counter-box">
                                <div class="count-number">
                                    <div class="number" data-speed="2000" data-to="85" data-inviewport="yes">500+</div>
                                </div>
                                <div class="title-count">Successful Catering Events</div>
                            </div>
                            <div class="counter-box">
                                <div class="count-number">
                                    <div class="number" data-speed="2000" data-to="112" data-inviewport="yes">15</div>
                                </div>
                                <div class="title-count">Years of Culinary Experience</div>
                            </div>
                            <div class="counter-box">
                                <div class="count-number">
                                    <div class="number" data-speed="2000" data-to="32" data-inviewport="yes">50+</div>
                                </div>
                                <div class="title-count">Authentic Vegetarian Dishes</div>
                            </div>
                            <div class="counter-box">
                                <div class="count-number">
                                    <div class="number" data-speed="2000" data-to="66" data-inviewport="yes">100%</div>
                                </div>
                                <div class="title-count">Pure Veg, No Onion & No Garlic Options</div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="section-gap-sm">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-8">
                                <div className="heading-title text-center mb-40">
                                    <h2>Exquisite Indian Vegetarian Catering Across Sydney</h2>
                                    <p>Bring vibrant Indian vegetarian flavours to your next event! We offer fresh, authentic dishes delivered across Sydney to make every occasion memorable and delicious.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <Swiper
                                    spaceBetween={15}
                                    slidesPerView={3}
                                    navigation={false}
                                    pagination={{ clickable: true }}
                                    modules={swiperModules}
                                >
                                    <SwiperSlide>
                                        <div class="edu-team-grid edu-team-grid-style-2">
                                            <div class="inner">
                                                <div class="thumbnail-wrap">
                                                    <div class="thumbnail">
                                                        <a href="#">
                                                            <img alt="Wedding &amp; Engagement Catering" src="/img/cat05.jpg" />
                                                        </a>
                                                    </div>
                                                </div>
                                                <div class="content">
                                                    <h2 class="title"><a href="#">Wedding & Engagement Catering</a></h2>
                                                    <p>Celebrate Love with Authentic Indian Flavors. A wedding is a celebration of traditions, joy, and togetherness. At Daadi's Kitchen, we craft authentic vegetarian feasts that honour your special moments, ensuring your guests enjoy a meal that's as memorable as your big day.</p>
                                                    <a href="#" onClick={(e) => { e.preventDefault(); cateringModal() }} class="btn-md btn btn-primary mt-2">Enquiry Now</a>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <div class="edu-team-grid edu-team-grid-style-2">
                                            <div class="inner">
                                                <div class="thumbnail-wrap">
                                                    <div class="thumbnail">
                                                        <a href="#">
                                                            <img alt="Haldi, Mehendi &amp; Sangeet Catering" src="/img/cat04.jpg" />
                                                        </a>
                                                    </div>
                                                </div>
                                                <div class="content">
                                                    <h2 class="title"><a href="#">Haldi, Mehendi & Sangeet Catering</a></h2>
                                                    <p>Vibrant, Festive, and Flavorful. Pre-wedding celebrations are all about fun, music, and delicious food! Our catering ensures your Haldi, Mehendi, and Sangeet are filled with flavorful delights that keep the energy high.</p>
                                                    <a href="#" onClick={(e) => { e.preventDefault(); cateringModal() }} class="btn-md btn btn-primary mt-2">Enquiry Now</a>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <div class="edu-team-grid edu-team-grid-style-2">
                                            <div class="inner">
                                                <div class="thumbnail-wrap">
                                                    <div class="thumbnail">
                                                        <a href="team-details.html">
                                                            <img alt="Reception Catering" src="/img/cat03.jpg" />
                                                        </a>
                                                    </div>
                                                </div>
                                                <div class="content">
                                                    <h2 class="title"><a href="#">Reception Catering</a></h2>
                                                    <p>An Elegant Feast to Mark the Beginning of Forever. Receptions call for a grand dining experience. Whether you prefer a traditional sit-down meal or a lively buffet.</p>
                                                    <a href="#" onClick={(e) => { e.preventDefault(); cateringModal() }} class="btn-md btn btn-primary mt-2">Enquiry Now</a>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <div class="edu-team-grid edu-team-grid-style-2">
                                            <div class="inner">
                                                <div class="thumbnail-wrap">
                                                    <div class="thumbnail">
                                                        <a href="team-details.html">
                                                            <img alt="Religious Event Catering" src="/img/cat02.jpg" />
                                                        </a>
                                                    </div>
                                                </div>
                                                <div class="content">
                                                    <h2 class="title"><a href="#">Pooja &amp; Religious Event Catering</a></h2>
                                                    <p>Pure, Sattvic, and Divine Offerings. For spiritual ceremonies, poojas, havans, and fasting days, we provide pure vegetarian meals prepared with care and devotion.</p>
                                                    <a href="#" onClick={(e) => { e.preventDefault(); cateringModal() }} class="btn-md btn btn-primary mt-2">Enquiry Now</a>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <div class="edu-team-grid edu-team-grid-style-2">
                                            <div class="inner">
                                                <div class="thumbnail-wrap">
                                                    <div class="thumbnail">
                                                        <a href="#">
                                                            <img src="/img/cat01.jpg" alt="team images" />
                                                        </a>
                                                    </div>
                                                </div>
                                                <div class="content">
                                                    <h2 class="title"><a href="#">Corporate Catering</a></h2>
                                                    <p>Elevate Your Workplace Gatherings with Authentic Indian Cuisine. Impress your team, clients, and colleagues with a curated menu that brings the best of Indian vegetarian cuisine to your business events.</p>
                                                    <a href="#" onClick={(e) => { e.preventDefault(); cateringModal() }} class="btn-md btn btn-primary mt-2">Enquiry Now</a>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <div class="edu-team-grid edu-team-grid-style-2">
                                            <div class="inner">
                                                <div class="thumbnail-wrap">
                                                    <div class="thumbnail">
                                                        <a href="#">
                                                            <img src="/img/cat06.jpg" alt="team images" />
                                                        </a>
                                                    </div>
                                                </div>
                                                <div class="content">
                                                    <h2 class="title"><a href="#">Personal & Family Gathering Catering</a></h2>
                                                    <p>Home-Style Indian Food for Every Occasion. From birthdays and anniversaries to family get-togethers and special celebrations, let us handle the food while you create beautiful memories.</p>
                                                    <a href="#" onClick={(e) => { e.preventDefault(); cateringModal() }} class="btn-md btn btn-primary mt-2">Enquiry Now</a>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                </Swiper>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer />
            </BrowserView>
            <MobileView>
                <AccountHeader heading='Catering'></AccountHeader>
                <video style={{ width: '100%', height: '300px', objectFit: 'cover' }} autoPlay muted loop>
                    <source src="/img/catering_intro.mp4" type="video/mp4" />
                </video>
                <section className="section-gap-sm services">
                    <div className="container">
                        <div className="section-title text-center">
                            <h2><span style={{ color: '#2ecc71' }}>Deliciously Different</span>&nbsp;<span style={{ color: '#3498db' }}>Exceptionally Memorable</span></h2>
                            <h5>Authentic Indian Vegetarian Catering Across Sydney</h5>
                            <p>At Daadi&#39;s Kitchen, we bring the warmth of traditional Indian flavours to your most cherished moments. As a 100% vegetarian caterer, we specialize in crafting fresh, home-style Indian cuisine for weddings, festivals, poojas, corporate events, and intimate gatherings.</p>
                            <p>With flexible staffed or unstaffed catering and pickup or delivery options available across Sydney, we make it effortless to serve up a feast your guests will love.</p>
                        </div>
                        <div className="row" style={{ textAlign: 'center' }}>
                            <div className="col-lg-12">
                                <h2 className="mb-3">Have a Catering Enquiry? Connect With Us!</h2>
                                <h4>Share Your Catering Requirements</h4>
                                <button type="button" className="btn-lg btn btn-primary mt-3" onClick={() => { cateringModal() }} >Make a Catering Enquiry Today</button>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="section-gap-md bg-light">
                    <div className="container">
                        <div className="flat-service">
                            <div className="row">
                                <div className="col-lg-3">
                                    <div className="box-service">
                                        <div className="icon-box">
                                            <img src="/img/catering.png" alt=""></img>
                                        </div>
                                        <div className="content">
                                            <h2 className="title">Live Catering</h2>
                                            <p class="description">Fresh dishes prepared on-site to deliver authentic flavours and a memorable dining experience.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3">
                                    <div className="box-service">
                                        <div className="icon-box">
                                            <img src="/img/onion.png" alt=""></img>
                                        </div>
                                        <div className="content">
                                            <h2 className="title">No Onion, No Garlic Menu</h2>
                                            <p class="description">Specially crafted pure vegetarian dishes made without onion and garlic, perfect for traditional and dietary preferences.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3">
                                    <div className="box-service">
                                        <div className="icon-box">
                                            <img src="/img/restaurant.png" alt=""></img>
                                        </div>
                                        <div className="content">
                                            <h2 className="title">Customisable Menu</h2>
                                            <p class="description">Choose from a wide range of Indian dishes tailored to your event’s needs.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3">
                                    <div className="box-service">
                                        <div className="icon-box">
                                            <img src="/img/fresh.png" alt=""></img>
                                        </div>
                                        <div className="content">
                                            <h2 className="title">Fresh & Hygienic Preparation</h2>
                                            <p class="description">Every dish is prepared with high-quality ingredients and strict hygiene standards.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wrap-counter">
                            <div class="counter-box">
                                <div class="count-number">
                                    <div class="number" data-speed="2000" data-to="85" data-inviewport="yes">500+</div>
                                </div>
                                <div class="title-count">Successful Catering Events</div>
                            </div>
                            <div class="counter-box">
                                <div class="count-number">
                                    <div class="number" data-speed="2000" data-to="112" data-inviewport="yes">15</div>
                                </div>
                                <div class="title-count">Years of Culinary Experience</div>
                            </div>
                            <div class="counter-box">
                                <div class="count-number">
                                    <div class="number" data-speed="2000" data-to="32" data-inviewport="yes">50+</div>
                                </div>
                                <div class="title-count">Authentic Vegetarian Dishes</div>
                            </div>
                            <div class="counter-box">
                                <div class="count-number">
                                    <div class="number" data-speed="2000" data-to="66" data-inviewport="yes">100%</div>
                                </div>
                                <div class="title-count">Pure Veg, No Onion & No Garlic Options</div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="section-gap-sm">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-8">
                                <div className="heading-title text-center mb-40">
                                    <h2>Exquisite Indian Vegetarian Catering Across Sydney</h2>
                                    <p>Bring vibrant Indian vegetarian flavours to your next event! We offer fresh, authentic dishes delivered across Sydney to make every occasion memorable and delicious.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <Swiper
                                    spaceBetween={15}
                                    slidesPerView={1}
                                    navigation={false}
                                    pagination={{ clickable: true }}
                                    modules={swiperModules}
                                >
                                    <SwiperSlide>
                                        <div class="edu-team-grid edu-team-grid-style-2">
                                            <div class="inner">
                                                <div class="thumbnail-wrap">
                                                    <div class="thumbnail">
                                                        <a href="#">
                                                            <img alt="Wedding &amp; Engagement Catering" src="/img/cat05.jpg" />
                                                        </a>
                                                    </div>
                                                </div>
                                                <div class="content">
                                                    <h2 class="title"><a href="#">Wedding & Engagement Catering</a></h2>
                                                    <p>Celebrate Love with Authentic Indian Flavors. A wedding is a celebration of traditions, joy, and togetherness. At Daadi's Kitchen, we craft authentic vegetarian feasts that honour your special moments, ensuring your guests enjoy a meal that's as memorable as your big day.</p>
                                                    <a href="#" onClick={(e) => { e.preventDefault(); cateringModal() }} class="btn-md btn btn-primary mt-2">Enquiry Now</a>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <div class="edu-team-grid edu-team-grid-style-2">
                                            <div class="inner">
                                                <div class="thumbnail-wrap">
                                                    <div class="thumbnail">
                                                        <a href="#">
                                                            <img alt="Haldi, Mehendi &amp; Sangeet Catering" src="/img/cat04.jpg" />
                                                        </a>
                                                    </div>
                                                </div>
                                                <div class="content">
                                                    <h2 class="title"><a href="#">Haldi, Mehendi & Sangeet Catering</a></h2>
                                                    <p>Vibrant, Festive, and Flavorful. Pre-wedding celebrations are all about fun, music, and delicious food! Our catering ensures your Haldi, Mehendi, and Sangeet are filled with flavorful delights that keep the energy high.</p>
                                                    <a href="#" onClick={(e) => { e.preventDefault(); cateringModal() }} class="btn-md btn btn-primary mt-2">Enquiry Now</a>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <div class="edu-team-grid edu-team-grid-style-2">
                                            <div class="inner">
                                                <div class="thumbnail-wrap">
                                                    <div class="thumbnail">
                                                        <a href="team-details.html">
                                                            <img alt="Reception Catering" src="/img/cat03.jpg" />
                                                        </a>
                                                    </div>
                                                </div>
                                                <div class="content">
                                                    <h2 class="title"><a href="#">Reception Catering</a></h2>
                                                    <p>An Elegant Feast to Mark the Beginning of Forever. Receptions call for a grand dining experience. Whether you prefer a traditional sit-down meal or a lively buffet.</p>
                                                    <a href="#" onClick={(e) => { e.preventDefault(); cateringModal() }} class="btn-md btn btn-primary mt-2">Enquiry Now</a>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <div class="edu-team-grid edu-team-grid-style-2">
                                            <div class="inner">
                                                <div class="thumbnail-wrap">
                                                    <div class="thumbnail">
                                                        <a href="team-details.html">
                                                            <img alt="Religious Event Catering" src="/img/cat02.jpg" />
                                                        </a>
                                                    </div>
                                                </div>
                                                <div class="content">
                                                    <h2 class="title"><a href="#">Pooja &amp; Religious Event Catering</a></h2>
                                                    <p>Pure, Sattvic, and Divine Offerings. For spiritual ceremonies, poojas, havans, and fasting days, we provide pure vegetarian meals prepared with care and devotion.</p>
                                                    <a href="#" onClick={(e) => { e.preventDefault(); cateringModal() }} class="btn-md btn btn-primary mt-2">Enquiry Now</a>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <div class="edu-team-grid edu-team-grid-style-2">
                                            <div class="inner">
                                                <div class="thumbnail-wrap">
                                                    <div class="thumbnail">
                                                        <a href="#">
                                                            <img src="/img/cat01.jpg" alt="team images" />
                                                        </a>
                                                    </div>
                                                </div>
                                                <div class="content">
                                                    <h2 class="title"><a href="#">Corporate Catering</a></h2>
                                                    <p>Elevate Your Workplace Gatherings with Authentic Indian Cuisine. Impress your team, clients, and colleagues with a curated menu that brings the best of Indian vegetarian cuisine to your business events.</p>
                                                    <a href="#" onClick={(e) => { e.preventDefault(); cateringModal() }} class="btn-md btn btn-primary mt-2">Enquiry Now</a>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <div class="edu-team-grid edu-team-grid-style-2">
                                            <div class="inner">
                                                <div class="thumbnail-wrap">
                                                    <div class="thumbnail">
                                                        <a href="#">
                                                            <img src="/img/cat06.jpg" alt="team images" />
                                                        </a>
                                                    </div>
                                                </div>
                                                <div class="content">
                                                    <h2 class="title"><a href="#">Personal & Family Gathering Catering</a></h2>
                                                    <p>Home-Style Indian Food for Every Occasion. From birthdays and anniversaries to family get-togethers and special celebrations, let us handle the food while you create beautiful memories.</p>
                                                    <a href="#" onClick={(e) => { e.preventDefault(); cateringModal() }} class="btn-md btn btn-primary mt-2">Enquiry Now</a>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                </Swiper>
                            </div>
                        </div>
                    </div>
                </section>
            </MobileView>
            {contextValues.toggleCateringModal && (<CateringBooking />)}
        </>
    )
}

export default Catering